/* AVRA_TOUCH_PEEK (2026-10-10, Brandon)
   Phones have no hover, so on a touch screen: rest a finger on a product
   photo and the card shows its other photo (the same photo desktop shows on
   hover). Lift the finger and it goes back to the first photo - it never
   stays stuck on the second one.

   - Works on every product card that has a second photo (.prod__media--alt):
     New Arrivals, Send a Hint, Complete the Look, collection pages.
   - Only a resting finger peeks. If the finger moves more than 8px (a swipe
     through the carousel or a scroll down the page) nothing changes, so
     swiping and scrolling stay clean.
   - A quick tap still opens the product. A long press that was used to peek
     does not open it, and the phone's link-preview pop-up is switched off on
     the photo so it cannot cover the peek.
   - Presses on the heart, Add to bag or the dots are left alone.
   The photo itself slides in sideways (avra-card-alt.css), never up/down. */
(function () {
  'use strict';
  var touchQ = window.matchMedia ? window.matchMedia('(hover: none), (pointer: coarse)') : null;
  function isTouch() { return !!(touchQ && touchQ.matches); }

  var st = document.createElement('style');
  st.textContent =
    '@media (hover: none), (pointer: coarse) {' +
    '.prod__media--alt, .prod__media--alt img, .prod__media--alt .prod__medialink {' +
    '-webkit-touch-callout: none; -webkit-user-select: none; user-select: none; }' +
    '.prod__media--alt.is-peek .prod__altimg { transform: translate(0) !important; opacity: 1 !important; }' +
    '}';
  (document.head || document.documentElement).appendChild(st);

  var DELAY = 110;      /* ms the finger must rest before the photo changes */
  var MOVE = 8;         /* px of movement that counts as a swipe / scroll */
  var media = null, timer = null, sx = 0, sy = 0, shownAt = 0, blockClickUntil = 0;

  function show() {
    timer = null;
    if (!media) return;
    media.classList.add('is-peek');
    shownAt = Date.now();
  }
  function reset() {
    if (timer) { clearTimeout(timer); timer = null; }
    if (media) {
      if (shownAt && Date.now() - shownAt > 250) blockClickUntil = Date.now() + 700;
      media.classList.remove('is-peek');
    }
    media = null;
    shownAt = 0;
  }

  document.addEventListener('touchstart', function (e) {
    reset();
    if (!isTouch() || e.touches.length !== 1) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.prod__fav, .prod__quick, .prod__dots, button')) return;
    var m = t.closest('.prod__media--alt');
    if (!m) return;
    media = m;
    sx = e.touches[0].clientX;
    sy = e.touches[0].clientY;
    timer = setTimeout(show, DELAY);
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!media) return;
    var t = e.touches[0];
    if (Math.abs(t.clientX - sx) > MOVE || Math.abs(t.clientY - sy) > MOVE) {
      shownAt = 0;           /* a swipe, not a peek: never block the click */
      reset();
    }
  }, { passive: true });

  document.addEventListener('touchend', reset, { passive: true });
  document.addEventListener('touchcancel', function () { shownAt = 0; reset(); }, { passive: true });
  window.addEventListener('scroll', function () { if (media) { shownAt = 0; reset(); } }, { passive: true });

  /* a long press used to look at the other photo should not open the page */
  document.addEventListener('click', function (e) {
    if (Date.now() < blockClickUntil && e.target && e.target.closest && e.target.closest('.prod__media--alt')) {
      e.preventDefault();
      e.stopPropagation();
      blockClickUntil = 0;
    }
  }, true);
  document.addEventListener('contextmenu', function (e) {
    if (isTouch() && e.target && e.target.closest && e.target.closest('.prod__media--alt')) e.preventDefault();
  });
})();
